import React from 'react';

import {
  InactiveCustomerBanner,
  useInactiveCustomerBanner,
} from 'src/app/banner/InactiveCustomerBanner';
import { NavBar } from 'src/common/NavBar';
import { TripRejectRequestModal } from 'src/features/dispatch/modals/requestedTrips/reject/TripRejectRequestModal';
import { useRejectTripRequestConfirmModalProps } from 'src/features/dispatch/modals/requestedTrips/reject/useRejectTripRequestConfirmModalProps';

export function Layout({ children }: { children: React.ReactNode }) {
  const shouldUseInactiveBanner = useInactiveCustomerBanner();
  const tripRejectRequestModalProps = useRejectTripRequestConfirmModalProps();

  return (
    <div className="flex flex-col gap-1">
      <NavBar />
      {shouldUseInactiveBanner ? <InactiveCustomerBanner /> : children}
      <TripRejectRequestModal props={tripRejectRequestModalProps} />
    </div>
  );
}
